<template>
  <BaseModal :state="state" :open="open" :close="onClose">
    <template #content>
      <EditarCamposTabs
        ref="tabsRef"
        v-model="tab"
        :initial-pergunta="pergunta"
        :initial-niveis="alternativas"
        @change:pergunta="onUpdatePergunta"
        @change:alternativas="onUpdateAlternativa"
      />

      <footer
        class="w-full h-80 bg-card-100 border-t border-neutral-100/10 p-16"
      >
        <div class="flex gap-8 justify-end">
          <OButton
            secondary
            size="md"
            :label="t('cancel')"
            class="text-headline-3"
            @click="onClose"
          />
          <OButton
            primary
            size="md"
            :label="t('saveChanges')"
            class="text-headline-3 !min-w-96"
            :disabled="!haveModfications"
            :loading="loading"
            @click="onSubmit"
          />
        </div>
      </footer>

      <BaseInnerLoader v-if="loading" />
    </template>
  </BaseModal>
</template>

<script setup>
import { ref, computed } from 'vue'
import { NotifyError } from 'js/vue/boot/Notify'
import { useI18n } from 'vue-i18n'
import BaseInnerLoader from 'components/Loader/BaseInnerLoader.vue'
import BaseModal from 'components/Modal/BaseModal.vue'
import EditarCamposTabs from 'components/Tabs/EditarCamposTabs.vue'
import OButton from 'components/Button/OButton.vue'
import useModal from 'composables/useModal'

const { t } = useI18n()
const modalEditarCampos = useModal()

const { setState, state, open, close } = modalEditarCampos

const props = defineProps({
  pergunta: { type: Object, default: () => ({}) },
  alternativas: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
})

const tab = ref('pergunta')
const tabsRef = ref(null)
const data = ref({
  pergunta: { ...props.pergunta },
  alternativas: [...props.alternativas],
})

const haveModfications = computed(() => {
  const perguntaChanged =
    JSON.stringify(data.value.pergunta) !==
    JSON.stringify(props.pergunta)

  const alternativasChanged =
    JSON.stringify(data.value.alternativas) !==
    JSON.stringify(props.alternativas)
  return perguntaChanged || alternativasChanged
})

function onUpdateAlternativa(updatedAlt) {
  const index = data.value.alternativas.findIndex(
    (alt) => alt.id === updatedAlt.id
  )
  if (index !== -1) {
    data.value.alternativas[index] = { ...updatedAlt }
  }
}

function onUpdatePergunta(updatedPergunta) {
  data.value.pergunta = { ...updatedPergunta }
}

async function onSubmit() {
  const isValid = await tabsRef.value?.validate()
  if (!isValid) {
    NotifyError(t('fillAllFields'))
    return
  }

  delete data.value.pergunta.alternativa_set
  emit('submit', {
    ...data.value.pergunta,
    alternativas: data.value.alternativas,
  })
}

const emit = defineEmits(['submit'])

const onClose = () => close()

setState({
  header: { title: t('editFields') },
  style: { width: '50rem', minHeight: '80vh' },
})

defineExpose({
  state,
  open,
  close,
  setState,
})
</script>
